<nz-card [routerLink]="item().route">
  <nz-card-meta
    [nzTitle]="item().title"
    [nzDescription]="item().description"
    [nzAvatar]="avatarTemplate"></nz-card-meta>
</nz-card>
<ng-template #avatarTemplate>
  <nz-icon
    style="scale: 2; margin-top: 1rem"
    [nzType]="item().icon"
    nzTheme="outline" />
</ng-template>